// TopBar.js

function TopBar() {
  return (
    <div className="top-bar" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <div className="top-bar-content">

        <div className="top-bar-links">
          <a href="#institutes">
            <span className="top-bar-icon">&#9632;</span>
            Institutes, Centres &amp; Units
          </a>
          <a href="#contacts">
            <span className="top-bar-icon">&#128196;</span>
            Contacts
          </a>
        </div>

        <div className="top-bar-right">
          <div className="top-bar-social">
            <a href="https://facebook.com" className="top-social-icon" aria-label="Facebook">f</a>
            <a href="https://youtube.com" className="top-social-icon" aria-label="YouTube">&#9654;</a>
            <a href="https://linkedin.com" className="top-social-icon" aria-label="LinkedIn">in</a>
          </div>
        </div>

      </div>
    </div>
  );
}

export default TopBar;